TPS.SpecialPinOffers = {
    accordionItems: null,

    init: function () {
        const _self = TPS.SpecialPinOffers;

        _self.accordionItems = document.querySelectorAll('.special-pin-offers-accordion-item');

        if (_self.accordionItems.length > 0) {
            _self.accordionItems.forEach(accordionItem => {
                const title = accordionItem.querySelector('.special-pin-offers-accordion-item-title');
                const content = accordionItem.querySelector('.special-pin-offers-accordion-item-content');

                if (!title || !content) return;
                
                title.addEventListener('click', (e) => {
                    // Ignore clicks on action buttons inside title
                    const actionBtn = e.target.closest('.special-pin-offers-accordion-item-action');
                    if (actionBtn) {
                        if (actionBtn.hasAttribute('disabled')) {
                            e.preventDefault();
                        }
                        return; // Do nothing if action button was clicked
                    }

                    _self.toggleAccordion(accordionItem, title, content);
                });

                // Keydown
                title.addEventListener('keydown', function (e) {
                    if (e.key === 'Enter' || e.key === ' ' || e.code === 'Space') {
                        const actionBtn = e.target.closest('.special-pin-offers-accordion-item-action');
                        if (actionBtn) {
                            if (actionBtn.hasAttribute('disabled')) {
                                e.preventDefault();
                            }
                            return;
                        }

                        e.preventDefault();
                        _self.toggleAccordion(accordionItem, title, content);
                    }
                });
            });
        }
    },

    toggleAccordion: function (item, title, content) {
        const isOpen = content.getAttribute('aria-hidden') === 'false';

        if (!isOpen) {
            item.classList.add('is-active');
            title.setAttribute('aria-expanded', 'true');
            title.setAttribute('aria-selected', 'true');
            content.setAttribute('aria-hidden', 'false');
            content.style.display = 'block';
        } else {
            item.classList.remove('is-active');
            title.setAttribute('aria-expanded', 'false');
            title.setAttribute('aria-selected', 'false');
            content.setAttribute('aria-hidden', 'true');
            content.style.display = 'none';
        }
    }
};


TPS.SpecialPinOffers.Form = {
    // Selectors
    formWrapperSelector: '#specialPinForm',
    countrySelector: '#country',
    customerStateSelector: '#customerState',
    errorBlockSelector: '#error-callout',
    successBlockSelector: '#success-callout',
    
    // Elements
    formWrapper: null,
    currentCulture: null,
    specialPINOfferInput: null,
    customerStateSelect: null,
    submitButton: null,
    specialPin: null,
    successMessageBlock: null,
    successMessage: null,
    successMessageValidateBtn: null,
    errorBlock: null,

    init: function () {
        const _self = TPS.SpecialPinOffers.Form;

        _self.formWrapper = document.querySelector(_self.formWrapperSelector);
        _self.currentCulture = document.querySelector('#lng');
        _self.specialPINOfferInput = document.querySelector('#specialPINOffer');
        _self.submitButton = document.querySelector('#specialPinFormActionSubmit');
        _self.specialPin = document.querySelector('[data-special-pin-created]');
        _self.successMessageBlock = document.querySelector('.special-pin-form-success-message');
        _self.successMessage = document.querySelector('.special-pin-form-title-description');
        _self.successMessageValidateBtn = document.querySelector('[data-validate-special-pin]');
        _self.errorBlock = document.querySelector(_self.errorBlockSelector);

        if (_self.formWrapper && _self.currentCulture) {
            window.validationMessages = window.validationMessages || {};
            TPS.Forms.setupClientValidation(_self.formWrapperSelector);
            _self.submitButtonToggle();
            _self.populateCountry(_self.currentCulture.value);
            _self.submitForm();
        }
    },

    populateCountry: function (_currentCulture) {
        const _self = TPS.SpecialPinOffers.Form;
        let countryId = 309; // Canada

        if (_currentCulture === "en-US") {
            countryId = 271; // USA
        }

        TPS.Util.initCountryStateDropDown(
            `${_self.formWrapperSelector} ${_self.countrySelector}`,
            `${_self.formWrapperSelector} ${_self.customerStateSelector}`,
            countryId,
            ""
        );
    },

    submitForm: function () {
        const _self = TPS.SpecialPinOffers.Form;

        const submitBtn = _self.formWrapper.querySelector('.submit-form');

        if (submitBtn) {
            submitBtn.addEventListener('click', function (e) {
                e.preventDefault();

                TPS.Forms.resetMessageBlock(`${_self.errorBlockSelector}, ${_self.successBlockSelector}`);

                TPS.Util.loadWebserviceJS('CMSApp.AV.API.Pin');

                if (TPS.Forms.validator.checkForm() && !submitBtn.classList.contains('submitting')) {
                    submitBtn.classList.add('submitting');
                    submitBtn.insertAdjacentHTML('beforeend', TPS.Util.submitSpinner);

                    const vals = TPS.Forms.getFormVals(_self.formWrapperSelector);

                    CMSApp.AV.API.Pin.CreateSpecialPin(
                        parseInt(vals.offerID),
                        vals.customerFirstName,
                        vals.customerLastName,
                        vals.customerAddress,
                        vals.customerCity,
                        vals.customerZIP,
                        parseInt(vals.customerState),
                        vals.customerEmail,
                        vals.customerPhone,
                        function (data) {
                            submitBtn.classList.remove('submitting');
                            const spinner = submitBtn.querySelector('.icon');
                            if (spinner) spinner.remove();

                            if (data.Success) {
                                if (_self.specialPin && _self.successMessageValidateBtn) {
                                    _self.specialPin.textContent = data.Object.PIN;
                                    _self.successMessage.innerHTML = window.labels.general.successMessage;
                                    _self.successMessageValidateBtn.setAttribute('href', `${window.labels.general.pinValidationUrl}${data.Object.PIN}`);
                                    _self.formWrapper.classList.add('hidden');
                                    _self.successMessageBlock.classList.remove('hidden');
                                }
                            } else {
                                console.error(data.ErrorMessages);
                                _self.errorBlock.innerHTML = '';
                                _self.errorBlock.classList.remove('hidden');
                                _self.errorBlock.style.display = 'block';
                                if (data.ErrorMessages && data.ErrorMessages.length > 0) {
                                    data.ErrorMessages.forEach(msg => {
                                        _self.errorBlock.innerHTML += `<p class="message">${msg.Value ? msg.Value : msg}</p>`;
                                    });
                                } else {
                                    _self.errorBlock.innerHTML = `<p class="message">${window.labels.general.formErrorMessage}}</p>`
                                }
                                _self.errorBlock.scrollIntoView({ block: "center" });
                            }
                        }
                    );
                } else {
                    console.log(TPS.Forms.validator.numberOfInvalids() + ' validation errors');
                    submitBtn.classList.remove('submitting');
                }
            });
        }
    },

    submitButtonToggle: function () {
        const _self = TPS.SpecialPinOffers.Form;

        const inputs = _self.formWrapper.querySelectorAll('input, select, textarea');
        inputs.forEach(function (el) {
            el.addEventListener('input', toggleState);
            el.addEventListener('change', toggleState);
        });

        function toggleState() {
            if (TPS.Forms.validator.checkForm()) {
                _self.submitButton.removeAttribute('disabled');
                _self.submitButton.classList.remove('disabled');
            } else {
                _self.submitButton.setAttribute('disabled', 'disabled');
                _self.submitButton.classList.add('disabled');
            }
        }
    }
};
